import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "sp-menu"
    }}>{`sp-menu`}</h1>
    <p><strong parentName="p">{`Since:`}</strong>{` UXP v4.1`}</p>
    <p>{`Renders a menu with menu items. Inside the `}<inlineCode parentName="p">{`sp-menu`}</inlineCode>{`, a series of `}<inlineCode parentName="p">{`sp-menu-item`}</inlineCode>{` or `}<inlineCode parentName="p">{`sp-menu-divider`}</inlineCode>{` elements may exist.`}</p>
    <p><img alt="Menus" src={require("../../assets/sp-menu.png")} /></p>
    <p><strong parentName="p">{`See`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://opensource.adobe.com/spectrum-web-components/components/menu"
        }}>{`https://opensource.adobe.com/spectrum-web-components/components/menu`}</a></li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-menu>
    <sp-menu-item> Deselect </sp-menu-item>
    <sp-menu-item> Select inverse </sp-menu-item>
    <sp-menu-item> Feather... </sp-menu-item>
    <sp-menu-item> Select and mask... </sp-menu-item>
    <sp-menu-divider></sp-menu-divider>
    <sp-menu-item> Save selection </sp-menu-item>
    <sp-menu-item disabled> Make work path </sp-menu-item>
</sp-menu>
`}</code></pre>
    <h2 {...{
      "id": "responding-to-events"
    }}>{`Responding to events`}</h2>
    <p>{`You can respond to changes in the menu using the `}<inlineCode parentName="p">{`change`}</inlineCode>{` event.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`document.querySelector(".yourMenu").addEventListener("change", evt => {
    console.log(\`Selected item: \${evt.target.selectedIndex}\`);
})
`}</code></pre>
    <h2 {...{
      "id": "quirks"
    }}>{`Quirks`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`sp-menu-divider`}</inlineCode>{` elements will only render inside an `}<inlineCode parentName="li">{`sp-dropdown`}</inlineCode>{`.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      